import Vue from "vue";
import Vuex from "vuex";

import _ from "lodash";
import axios from "axios";
// import config from "../config";
// import moment from "moment";

Vue.use(Vuex);

let request_datestart = window.localStorage.getItem("request_datestart")
  ? window.localStorage.getItem("request_datestart")
  : "";
let request_datestop = window.localStorage.getItem("request_datestop")
  ? window.localStorage.getItem("request_datestop")
  : "";
let accesstoken = window.localStorage.getItem("accesstoken")
  ? window.localStorage.getItem("accesstoken")
  : "";
let refreshtoken = window.localStorage.getItem("refreshtoken")
  ? window.localStorage.getItem("refreshtoken")
  : "";
let lang = window.localStorage.getItem("pvn_lang")
  ? window.localStorage.getItem("pvn_lang")
  : "en";
let favories = [];
if (window.localStorage.getItem("pvn_offers_favories")) {
  try {
    favories = JSON.parse(window.localStorage.getItem("pvn_offers_favories"));
  } catch (error) {
    console.error("error", error);
  }
}

let defaultUser = {
  co_id: "",
  co_name: "",
  co_firstname: "",
  co_function: "",
  co_mobile1: "",
  co_tel1: "",
  co_email1: "",
  co_type: ""
};
let user = _.cloneDeep(defaultUser);

/* let items_0A10 = [
  { value: 0, text: "0" },
  { value: 1, text: "1" },
  { value: 2, text: "2" },
  { value: 3, text: "3" },
  { value: 4, text: "4" },
  { value: 5, text: "5" },
  { value: 6, text: "6" },
  { value: 7, text: "7" },
  { value: 8, text: "8" },
  { value: 9, text: "9" },
  { value: 10, text: "10" }
]; */

/* let items_civility_simple = [
  {
    value: "mme",
    text: "Madame",
    sex: 2
  },
  {
    value: "m",
    text: "Monsieur",
    sex: 1
  }
]; */

export default new Vuex.Store({
  state: {
    traductions_fr: { translation: {} },
    traductions_en: { translation: {} },
    traductions_sp: { translation: {} },
    traductions_ru: { translation: {} },
    traductions_it: { translation: {} },
    lang,
    items: {},
    items_of_exclusivite: [],
    itemsloaded: false,
    traductionsloaded: false,
    myactions: [],
    isMainLoading: false,
    currentcontact: null,
    // lastcoid: "",
    mysocket: null,
    connected: false,
    accesstoken,
    request_datestart,
    request_datestop,
    favories,
    refreshtoken,
    user,
    preferences: {
      personal: {},
      shared: {},
      rights: {}
    },
    reload_actions: 0,
    inputOpened: null,
    dialogErr: false,
    dialogErrTxt: "",
    socketmessage: {},
    nbnewmessages: [],
    offersfilters: {
      page: 1,
      room: false,
      room_1: false,
      room_2: false,
      room_3: false,
      room_4: false,
      room_5: false,
      types: [],
      typesobj: {},
      district: "",
      france: false,
      monaco: false,
      international: false,
      rent: false,
      sale: false,
      budget: "",
      budgetmin: 0,
      budgetmax: 400000000
      // surface: "",
      // surfacemin: "",
      // surfacemax: "",
      // datestart: "",
      // dateend: "",
      // agency: "",
      // district: "",
      // text: "",
      // type: "",
      // favories: []
    }
  },
  mutations: {
    set_favories(state, favories) {
      window.localStorage.setItem(
        "pvn_offers_favories",
        JSON.stringify(favories)
      );
      state.favories = favories;
    },
    set_lang(state, lang) {
      window.localStorage.setItem("pvn_lang", lang);
      state.lang = lang;
    },
    set_offers(state, data) {
      window.localStorage.setItem(
        "pvn_web_offers_search",
        JSON.stringify(data.offers)
      );
      //state.offers = data.offers;
      // console.log("sate.offers", state.offers);
    },
    set_items(state, data) {
      // console.log("data.items", data.items);
      /*       if (data.items.schools) {
        let items_school = [];
        for (let isc = 0; isc < data.items.schools.length; isc++) {
          const school = data.items.schools[isc];
          items_school.push({ text: school.sc_name, value: school.sc_slug });
        }
        data.items.schools = items_school;
      } */
      for (let itype = 0; itype < data.items.items_of_type.length; itype++) {
        const type = data.items.items_of_type[itype];
        state.offersfilters.typesobj[type.text] = false;
      }
      state.items = data.items;
      state.items_of_exclusivite = data.items.items_of_exclusivite;
      // console.log(
      //   "state.items_of_exclusivite",
      //   data.items.items_of_exclusivite
      // );
      state.itemsloaded = true;
    },
    set_traductions(state, data) {
      for (let itrad = 0; itrad < data.traductions.length; itrad++) {
        const trad = data.traductions[itrad];
        state.traductions_fr.translation[trad.tr_key] = trad.tr_fr;
        state.traductions_en.translation[trad.tr_key] = trad.tr_en;
        state.traductions_sp.translation[trad.tr_key] = trad.tr_sp;
        state.traductions_ru.translation[trad.tr_key] = trad.tr_ru;
        state.traductions_it.translation[trad.tr_key] = trad.tr_it;
      }
      state.traductionsloaded = true;
    },
    set_myactions(state, data) {
      state.myactions = data;
    },
    set_offersfilters(state, offersfilters) {
      //console.log("offersfilters", offersfilters);
      state.offersfilters = _.cloneDeep(offersfilters);
    },
    set_nbnewmessages(state, rows_mnr) {
      state.nbnewmessages = rows_mnr;
    },
    set_socketmessage(state, data) {
      state.socketmessage = data;
    },
    set_inputOpened(state, input) {
      if (input) {
        if (state.inputOpened && input.name !== state.inputOpened.name) {
          state.inputOpened.hideDropdown();
        }
        state.inputOpened = input;
      } else {
        state.inputOpened = null;
      }
    },
    set_currentcontact(state, val) {
      state.currentcontact = val;
    },
    set_mainisloading(state, ok) {
      state.isMainLoading = ok;
    },
    // set_lastcoid(state, co_id) {
    //   state.lastcoid = co_id;
    // },
    set_mysocket(state, socket) {
      state.mysocket = socket;
    },
    set_reload_actions(state) {
      state.reload_actions = Math.random();
    },
    // utiliser simplement pour mettre à jour les infos essentielles
    set_user_simple(state, user) {
      state.user.co_name = user.co_name;
      state.user.co_firstname = user.co_firstname;
      state.user.co_type = user.co_type;
      state.user.updatedAt = user.updatedAt;
    },
    set_requestdates(state, dates) {
      state.request_datestart = dates.datestart;
      state.request_datestop = dates.datestop;
      window.localStorage.setItem("request_datestart", dates.datestart);
      window.localStorage.setItem("request_datestop", dates.datestop);
    },
    set_tokens(state, what) {
      axios.defaults.headers.common["x-auth-accesstoken"] = what.accesstoken;
      window.localStorage.setItem("accesstoken", what.accesstoken);
      state.accesstoken = what.accesstoken;
      window.localStorage.setItem("refreshtoken", what.refreshtoken);
      state.refreshtoken = what.refreshtoken;
    },
    set_connexion(state, what) {
      if (!what.accesstoken) {
        axios.defaults.headers.common["x-auth-accesstoken"] = "";
        window.localStorage.removeItem("accesstoken");
        state.accesstoken = null;
        window.localStorage.removeItem("refreshtoken");
        state.refreshtoken = null;
        window.localStorage.removeItem("pvn-web-user");
        state.user = _.cloneDeep(defaultUser);
        //console.log("state.user", state.user);
        state.connected = false;
        this.dispatch("socketunjoinroom");
        return;
      }
      // console.log("token, refreshtoken, user", what.accesstoken, what.refreshtoken, what.user);
      axios.defaults.headers.common["x-auth-accesstoken"] = what.accesstoken;
      window.localStorage.setItem("accesstoken", what.accesstoken);
      state.accesstoken = what.accesstoken;
      //window.localStorage.setItem("refreshtoken", what.refreshtoken);
      //state.refreshtoken = what.refreshtoken;
      what.user.co_password = "";
      window.localStorage.setItem("pvn-web-user", JSON.stringify(what.user));
      state.user = _.cloneDeep(what.user);
      // state.preferences = _.cloneDeep(what.preferences);
      // console.log("what.preferences", what.preferences);
      /*       _.each(what.preferences.items, (val, key) => {
        state[key] = what.preferences.items[key];
      }); */

      state.connected = true;
      // this.dispatch("load_nbclientsuivi");
      this.dispatch("socketjoinroom");
      //this.dispatch("updateNbNewMessages");
      this.dispatch("updateMyActions");
    },
    set_preferences(state, data) {
      state.preferences[data.preference] = data.data;
    },
    set_dialog_error(state, what) {
      // console.log("what", what);
      state.dialogErr = what.dialogErr;
      state.dialogErrTxt = what.dialogErrTxt;
    }
  },
  actions: {
    addFavorite(ctx, of_id) {
      // console.log("of_id", of_id);
      let favories = _.cloneDeep(ctx.state.favories);
      if (favories.indexOf(of_id) >= 0) {
        _.pull(favories, of_id);
      } else {
        favories.push(of_id);
      }
      ctx.commit("set_favories", favories);
    },
    cancelAllFilter(ctx) {
      ctx.state.offersfilters.page = 1;
      ctx.state.offersfilters.types = [];
      ctx.state.offersfilters.typesobj = {};
      // this.type = 0;
      ctx.state.offersfilters.room_1 = false;
      ctx.state.offersfilters.room_2 = false;
      ctx.state.offersfilters.room_3 = false;
      ctx.state.offersfilters.room_4 = false;
      ctx.state.offersfilters.room_5 = false;
      ctx.state.offersfilters.monaco = false;
      ctx.state.offersfilters.france = false;
      ctx.state.offersfilters.international = false;
      ctx.state.offersfilters.district = "";
      ctx.state.offersfilters.rent = false;
      ctx.state.offersfilters.sale = false;
      ctx.state.offersfilters.budgetmin = 0;
      ctx.state.offersfilters.budgetmax = 400000000;
      ctx.state.offersfilters.favories = [];
      // this.sale = 0;
    },
    async updateMyActions(ctx) {
      if (!ctx.state.connected) return;
      let response = await axios.get(
        this._vm.$config.server_url + "/web/1.0/actions",
        {
          headers: {
            "x-auth-webaccesstoken": ctx.state.user.co_accesstoken
          }
        }
      );
      ctx.commit("set_myactions", response.data.data);
    },
    showDialogError(ctx, err) {
      ctx.commit("set_dialog_error", {
        dialogErr: err ? true : false,
        dialogErrTxt: err ? err : ""
      });
    },
    SOCKET_connect(ctx) {
      // if (ctx.state.user && ctx.state.user.co_id && ctx.state.mysocket)
      //   ctx.state.mysocket.emit("join", ctx.state.user.co_id);
    },
    SOCKET_message(ctx, data) {
      ctx.commit("set_socketmessage", data);
      ctx.dispatch("updateNbNewMessages");
    },
    updateNbNewMessages(ctx) {
      // le timout permet de mettre à jour le nombre le nmbre de nouveaux messages avec un petit retard au cas où le mec est sur un fil de discussion et il a du coup déjà lu
      setTimeout(async () => {
        if (!ctx.state.user || !ctx.state.user.co_id) return;
        let response = await axios.get(
          this._vm.$config.server_url +
            "/api/1.0/messages/" +
            ctx.state.user.co_id +
            "/notread",
          {}
        );
        ctx.commit("set_nbnewmessages", response.data.data);
      }, 500);
    },
    socketjoinroom(ctx) {
      if (ctx.state.user && ctx.state.user.co_id)
        this._vm.$socket.emit("join", ctx.state.user.co_id);
    },
    socketunjoinroom(ctx) {
      this._vm.$socket.emit("unjoin", ctx.state.user.co_id);
    }
  },
  modules: {},
  getters: {
    get_inputOpened(state) {
      return state.inputOpened;
    }
  }
});
